import React, { useEffect } from "react";
import { useParams } from "react-router-dom";

/**
 * The prospect-facing proposal page, on the app's own host.
 *
 * Links go out as my.getmulch.com/p/<token>. This route is PUBLIC - no
 * login, no app chrome - and frames the document that the API renders at
 * /p/<token>. The password gate, the view tracking and the document itself
 * all live in that API page; this component only gives it a real address on
 * a host that resolves. (proposals.getmulch.com, the Railway MVP's host,
 * never had a DNS record - 2026-09-23.)
 *
 * An iframe rather than fetch-and-inject: the password form inside the page
 * posts back to the API relative to its own origin, which only works when the
 * page is loaded from that origin.
 */
const PublicProposal = () => {
  const { token } = useParams();
  const backend = (process.env.REACT_APP_BACKEND || "").replace(/\/+$/, "");
  const src = token ? `${backend}/p/${encodeURIComponent(token)}` : "";

  useEffect(() => {
    document.title = "Proposal | GetMulch";
  }, []);

  if (!token || !backend) {
    return (
      <div style={{ fontFamily: "Poppins, sans-serif", padding: 40, textAlign: "center" }}>
        This link isn&apos;t valid.
      </div>
    );
  }

  return (
    <iframe
      title="Proposal"
      src={src}
      style={{ position: "fixed", inset: 0, width: "100%", height: "100%", border: 0, background: "#fff" }}
    />
  );
};

export default PublicProposal;
